import { applyMiddleware, compose, createStore } from "redux";
import createSagaMiddleware from "redux-saga";
import storage from "redux-persist/lib/storage";
import rootReducer from "./reducers";
import rootSaga from "./sagas";
import { persistReducer, persistStore } from "redux-persist";

const composeEnhancers =
  typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    : compose;

const bindMiddleware = (middleware) => {
  if (process.env.NODE_ENV !== "production") {
    return composeEnhancers(applyMiddleware(...middleware));
  }
  return composeEnhancers(applyMiddleware(...middleware));
};

export const makeStore = () => {
  const sagaMiddleware = createSagaMiddleware();

  const persistConfig = {
    key: "storage",
    whitelist: [], // make sure it does not clash with server keys
    storage,
  };
  const persistedReducer = persistReducer(persistConfig, rootReducer);
  const store = createStore(persistedReducer, bindMiddleware([sagaMiddleware]));

  store.__persistor = persistStore(store); // Nasty hack
  store.sagaTask = sagaMiddleware.run(rootSaga);

  return store;
};
